module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/hairstyle_03@3x-72adcfb733dfaa7ef0d9c5d235ea06ec.webp";